import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals.js';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './index.css';


// PAGES ===========================>
import SmartMenu from './pages/smartmenu/index.jsx';
import Menu from './pages/menu/index.jsx';
import Cart from './pages/cart/index.jsx';
import Account from './pages/account/index.jsx';
import Product from './pages/product/index.jsx';
import Register from './pages/register/index.jsx';
import RegisterDeliveryData from './pages/registerDeliveryData/index.jsx';
import About from './pages/about/index.jsx';
import NotFound from './pages/notFound/index.jsx';


// CONTEXTS ===========================>
import { CompanyContextProvider } from './contexts/companyContext.js';
import { CatalogContextProvider } from './contexts/catalogContext.js';
import { LocationContextProvider } from './contexts/locationContext.js';
import { ClientDataContextProvider } from './contexts/clientContext.js';
import { LoadingContextProvider } from './contexts/loadingContext.js';



const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <LoadingContextProvider>
        <CompanyContextProvider>
            <ClientDataContextProvider>
                <LocationContextProvider>
                    <CatalogContextProvider>
                        <BrowserRouter>
                            <Routes>
                                {/* <=================== ROTAS PARA CARDÁPIO ===================> */}

                                <Route path="/:company/:companyId" element={<SmartMenu />}>
                                    <Route index element={<Menu />} />
                                    
                                    <Route path="menu" element={<Menu />} />
                                    <Route path="about" element={<About />} />
                                    <Route path="product/:productId" element={<Product />} /> 

                                    <Route path="cart" element={<Cart />} />
                                    <Route path="register" element={<Register />} />
                                    <Route path="register/delivery" element={<RegisterDeliveryData />} />

                                    <Route path="account" element={<Account />} />

                                    {/* Redirecionamento padrão caso digitem rota inexistente */}
                                    <Route path="*" element={<NotFound />} />
                                </Route>

                                <Route path="*" element={<NotFound />} />

                                {/* ============================================================> */}
                            </Routes>
                        </BrowserRouter>
                    </CatalogContextProvider>
                </LocationContextProvider>
            </ClientDataContextProvider>
        </CompanyContextProvider>
    </LoadingContextProvider>
);

reportWebVitals();
